module.exports = __webpack_public_path__ + "img/top_coaches_badge.74b1eb52.png";